// extracted by mini-css-extract-plugin
export default {"wrapper":"HeroSection_wrapper__D9Qdk","hero":"HeroSection_hero__yRGTA"};